module.exports = __webpack_public_path__ + "media/demo-event-loader/loader@2x-df7a601d.png";